import { useEffect } from "react"
import { connectCustomer, connectSession } from "@/store/sessionSync"

/**
 * Subscribes to a session for as long as the component is mounted, and
 * releases it on unmount. Safe to call from more than one component and safe
 * under React StrictMode — the connection is reference counted, so double
 * invocation does not open duplicate listeners.
 *
 * Read the data with `useSessionStore(...)`; this hook only manages the
 * subscription lifetime.
 */
export function useSessionConnection(sessionId: string | undefined | null): void {
  useEffect(() => {
    if (!sessionId) return
    return connectSession(sessionId)
  }, [sessionId])
}

/** Same, for the current customer document. */
export function useCustomerConnection(customerId: string | undefined | null): void {
  useEffect(() => {
    if (!customerId) return
    return connectCustomer(customerId)
  }, [customerId])
}
